// Helper function to convert cell address (e.g., "B2") to row/column indices
export const cellAddressToIndices = (
  address: string,
): { row: number; column: number } => {
  const match = address.match(/^([A-Z]+)(\d+)$/)
  if (!match) {
    throw new Error(`Invalid cell address: ${address}`)
  }

  const colLetters = match[1]
  const rowNumber = parseInt(match[2], 10)

  // Convert column letters to index (A=0, B=1, Z=25, AA=26, etc.)
  let column = 0
  for (let i = 0; i < colLetters.length; i++) {
    column = column * 26 + (colLetters.charCodeAt(i) - 64)
  }
  column -= 1 // Convert to 0-based index

  // Convert row number to 0-based index
  const row = rowNumber - 1

  return { row, column }
}
